import { bootstrap as bootstrapExperiments, init as initAnalytics, track } from '@sloyd/analytics';
import { initOpenAI, setStore as setStoreApi } from '@sloyd/api';
import { initFirebase } from '@sloyd/auth';
import { init as initPay } from '@sloyd/pay';
import { actions, initIdb, selectors } from '@sloyd/store-base';
import { setAnalyticsMethod as setAnalyticsMethodUI, setBridge, setWebAssetsUrl } from '@sloyd/ui'; // prettier-ignore
import { bridge } from '@sloyd/viewer';
import { getJson, guid4, invokeEvent, setString } from 'shared-base';
import p from '../package.json';
import { paddleConfig } from './main.paddle';
import { initStore } from './store';
import { setStore } from './utils/globals';

export const clientId = `client_${guid4()}`;

const settings = bootstrapExperiments();

export const store = initStore(clientId, settings);
const savedSettings = getJson('SETTINGS') ?? {};

const openAIKey = (import.meta.env.VITE_OPEN_AI_KEY || savedSettings?.openAiKey).trim();

const env = import.meta.env;

setStore(store);
setStoreApi(store);

initFirebase(import.meta.env.VITE_FIREBASE_CONFIG);

// @ts-ignore
window.store = store;
// @ts-ignore

setString('version', p.version);

setWebAssetsUrl(import.meta.env.VITE_WEB_ASSETS_URL);
setAnalyticsMethodUI(track);
setBridge(bridge);

initIdb();

if (openAIKey) {
  initOpenAI(openAIKey);
}

try {
  initPay(paddleConfig.token, paddleConfig.priceIds, paddleConfig.discountIds, {
    environment: paddleConfig.environment,
  });
} catch (err) {
  invokeEvent('sentry', { err });
}

initAnalytics(import.meta.env.VITE_MIXPANEL_TOKEN, {
  // enabled: true,
  enabled: env.MODE === 'production',
  env: env.MODE,
  selectors: selectors.analytics,
  skipEmployees: false,
  store,
});

const openAiKey = import.meta.env.VITE_OPEN_AI_KEY;

if (openAiKey) {
  store.dispatch(
    actions.settings.patch({
      openAiKey,
    })
  );
}
